import React from 'react';
import { Box } from '@mui/material';
import styles from './ReadonlyFormField.module.scss';

export interface ReadonlyFormFieldProps {
	label: string;
	value?: string | number | null;
	multiline?: boolean;
	minRows?: number;
}

const ReadonlyFormField: React.FC<ReadonlyFormFieldProps> = ({
	label,
	value,
	multiline = false,
	minRows = 3,
}) => {
	const stringValue = value === null || value === undefined ? '' : String(value);
	const displayValue = stringValue.trim() ? stringValue : '—';
	const multilineStyle =
		multiline && minRows > 3 ? { minHeight: minRows * 24 + 32 } : undefined;

	return (
		<Box>
			<label className={styles.formLabel}>{label}</label>
			<div
				className={`${styles.readonlyValue}${multiline ? ` ${styles.readonlyValueMultiline}` : ''}`}
				style={multilineStyle}
			>
				{displayValue}
			</div>
		</Box>
	);
};

export default ReadonlyFormField;
